import { assertInInjectionContext, inject, Injector, runInInjectionContext } from '@angular/core';
import { AuthenticatedResult, OidcSecurityService } from 'angular-auth-oidc-client';
import { fromUnixTime, isAfter } from 'date-fns';
import { Observable, pipe, switchMap, tap, UnaryFunction, withLatestFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoggerWithConfigurationService } from '../service/internal/logger-with-configuration.service';
import { createPrefixMessage } from './prefix-message.function';

export function checkIfRefreshIsRequired(
  injector?: Injector,
): UnaryFunction<Observable<unknown>, Observable<boolean>> {
  if (!injector) {
    assertInInjectionContext(checkIfRefreshIsRequired);
    injector = inject(Injector);
  }
  return runInInjectionContext(injector, () => {
    const prefixMessage = createPrefixMessage('checkIfRefreshIsRequired');
    const loggerService = inject(LoggerWithConfigurationService);
    const oidcSecurityService = inject(OidcSecurityService);
    return pipe(
      tap(() => {
        loggerService.logDebug(prefixMessage(`Checking if this window has a valid token.`));
      }),
      switchMap(() =>
        oidcSecurityService.isAuthenticated$.pipe(
          withLatestFrom(oidcSecurityService.getPayloadFromAccessToken()),
          map(
            ([{ isAuthenticated }, accessToken]: [
              AuthenticatedResult,
              { exp: number; iad: number },
            ]) => {
              const needsRefresh =
                !isAuthenticated || isAfter(new Date(), fromUnixTime(accessToken.exp));
              if (!needsRefresh) {
                loggerService.logDebug(
                  prefixMessage(`This window has a valid token. No refresh needed.`),
                );
              } else {
                loggerService.logDebug(
                  prefixMessage(`Token invalid refresh needed waiting for refresh...`),
                );
              }

              return needsRefresh;
            },
          ),
        ),
      ),
    );
  });
}
